// UI translations for the three launch languages. Missing keys fall back to
// English, then to the key itself. Add a new language by adding an object here.
const en = {
  // header / nav
  search_placeholder: "Search products, brands and categories",
  all_categories: "All Categories",
  account: "Account",
  hello_sign_in: "Hello, sign in",
  my_account: "My Account",
  orders: "Orders",
  wishlist: "Wishlist",
  cart: "Cart",
  login: "Sign in",
  register: "Register",
  logout: "Log out",
  track_order: "Track order",
  language: "Language",
  currency: "Currency",
  // announcement
  announce_shipping: "Free shipping on orders over $50 · Worldwide delivery",
  announce_protection: "Buyer protection on every order",
  // home
  hero_title: "Discover more. Pay less.",
  hero_subtitle: "Thousands of products, one premium marketplace.",
  shop_now: "Shop now",
  explore_deals: "Explore deals",
  featured_categories: "Featured categories",
  best_sellers: "Best sellers",
  trending: "Trending now",
  flash_deals: "Flash deals",
  new_arrivals: "New arrivals",
  recommended: "Recommended for you",
  recently_viewed: "Recently viewed",
  view_all: "View all",
  ends_in: "Ends in",
  // trust
  trust_secure: "Secure payments",
  trust_secure_d: "Encrypted checkout you can trust",
  trust_protection: "Buyer protection",
  trust_protection_d: "Full refund if it doesn't arrive",
  trust_returns: "Easy returns",
  trust_returns_d: "Hassle-free returns policy",
  trust_support: "24/7 support",
  trust_support_d: "We're here whenever you need us",
  newsletter_title: "Get exclusive deals in your inbox",
  newsletter_sub: "Subscribe for early access to drops and offers.",
  subscribe: "Subscribe",
  email_placeholder: "Enter your email",
  subscribed: "Thanks for subscribing!",
  // product / listing
  add_to_cart: "Add to cart",
  buy_now: "Buy now",
  in_stock: "In stock",
  out_of_stock: "Out of stock",
  reviews: "reviews",
  no_reviews: "No reviews yet",
  reviews_tab: "Reviews",
  order_confirmed: "Order confirmed",
  color: "Color",
  size: "Size",
  quantity: "Quantity",
  add_to_wishlist: "Add to wishlist",
  in_wishlist: "In wishlist",
  description: "Description",
  specifications: "Specifications",
  related_products: "Related products",
  similar_products: "You may also like",
  frequently_bought: "Frequently bought together",
  estimated_delivery: "Estimated delivery",
  ships_to: "Ships to",
  buyer_protection: "Buyer protection & guarantees",
  select_options: "Select options",
  filters: "Filters",
  sort: "Sort",
  price: "Price",
  rating: "Rating",
  availability: "Availability",
  in_stock_only: "In stock only",
  on_sale: "On sale",
  brand: "Brand",
  apply: "Apply",
  clear_all: "Clear all",
  sort_relevance: "Relevance",
  sort_price_asc: "Price: low to high",
  sort_price_desc: "Price: high to low",
  sort_rating: "Top rated",
  sort_newest: "Newest",
  results: "results",
  min: "Min",
  max: "Max",
  // empty states
  no_products_title: "No products to show yet",
  no_products_body: "Connect your WooCommerce store or adjust your filters to see products here.",
  connect_store: "Products, prices and inventory load from WooCommerce.",
  // cart
  cart_title: "Shopping cart",
  cart_empty_title: "Your cart is empty",
  cart_empty_body: "Browse the store and add items you love.",
  subtotal: "Subtotal",
  shipping: "Shipping",
  shipping_calc: "Calculated at checkout",
  estimated_total: "Estimated total",
  coupon: "Coupon code",
  proceed_checkout: "Proceed to checkout",
  remove: "Remove",
  save_for_later: "Save for later",
  continue_shopping: "Continue shopping",
  // checkout
  checkout_title: "Checkout",
  contact_info: "Contact information",
  shipping_address: "Shipping address",
  billing_same: "Billing address same as shipping",
  full_name: "Full name",
  email: "Email",
  phone: "Phone",
  country: "Country",
  city: "City",
  postal_code: "Postal code",
  address_line: "Address",
  shipping_method: "Shipping method",
  payment_method: "Payment method",
  payment_note: "Payment gateways are modular and connect to WooCommerce. No card data is stored here.",
  order_notes: "Order notes (optional)",
  place_order: "Place order",
  order_summary: "Order summary",
  // account
  dashboard: "Dashboard",
  my_orders: "My orders",
  addresses: "Addresses",
  profile: "Profile",
  security: "Security",
  welcome_back: "Welcome back",
  no_orders_title: "No orders yet",
  no_orders_body: "When you place an order it will appear here with live status and tracking.",
  order_number: "Order number",
  status: "Status",
  total: "Total",
  view: "View",
  // order statuses
  st_received: "Order received",
  st_processing: "Processing",
  st_purchased: "Purchased from supplier",
  st_preparing: "Preparing shipment",
  st_shipped: "Shipped",
  st_in_transit: "In transit",
  st_delivered: "Delivered",
  st_cancelled: "Cancelled",
  st_refunded: "Refunded",
  // tracking
  track_title: "Track your order",
  track_sub: "Enter your order number to see the latest status.",
  tracking_number: "Tracking number",
  carrier: "Carrier",
  timeline: "Shipment timeline",
  track_btn: "Track",
  no_tracking: "No tracking information is available for this order yet.",
  // auth
  sign_in: "Sign in",
  create_account: "Create account",
  password: "Password",
  name: "Name",
  no_account: "New to KHA?",
  have_account: "Already have an account?",
  auth_local_note: "Accounts connect to WooCommerce customer accounts once your backend is linked.",
  auth_failed_generic: "Something went wrong. Please try again.",
  forgot_password: "Forgot password?",
  send_reset_link: "Send reset link",
  reset_sent: "If the email exists, a password reset link has been sent.",
  reset_done: "Password updated. You can now sign in with your new password.",
  reset_note: "Choose a new password for your account.",
  reset_password_btn: "Set new password",
  or_continue_with: "or continue with",
  google_sign_in: "Sign in with Google",
  google_not_configured: "Google sign-in is not configured yet. The owner needs to add Google OAuth credentials in the store settings.",
  current_password: "Current password",
  new_password: "New password",
  profile_saved: "Profile updated successfully.",
  about_us: "About Us",
  contact_us: "Contact Us",
  shipping_policy: "Shipping & Delivery",
  returns_policy: "Returns & Refunds",
  cancellation_policy: "Cancellation",
  terms_conditions: "Terms & Conditions",
  privacy_policy: "Privacy Policy",
  cookie_policy: "Cookie Policy",
  faq: "FAQ",
  order_tracking: "Order Tracking",
  // misc
  home: "Home",
  page_not_found: "Page not found",
  go_home: "Back to home",
};

const tr = {
  search_placeholder: "Ürün, marka ve kategori ara",
  all_categories: "Tüm Kategoriler",
  account: "Hesap",
  hello_sign_in: "Merhaba, giriş yap",
  my_account: "Hesabım",
  orders: "Siparişler",
  wishlist: "Favoriler",
  cart: "Sepet",
  login: "Giriş yap",
  register: "Kayıt ol",
  logout: "Çıkış yap",
  track_order: "Sipariş takip",
  language: "Dil",
  currency: "Para birimi",
  announce_shipping: "50$ üzeri siparişlerde ücretsiz kargo · Dünya geneli teslimat",
  announce_protection: "Her siparişte alıcı koruması",
  hero_title: "Daha fazlasını keşfet. Daha az öde.",
  hero_subtitle: "Binlerce ürün, tek bir premium pazar yeri.",
  shop_now: "Alışverişe başla",
  explore_deals: "Fırsatları keşfet",
  featured_categories: "Öne çıkan kategoriler",
  best_sellers: "Çok satanlar",
  trending: "Şu an popüler",
  flash_deals: "Flaş indirimler",
  new_arrivals: "Yeni gelenler",
  recommended: "Sana özel öneriler",
  recently_viewed: "Son görüntülenenler",
  view_all: "Tümünü gör",
  ends_in: "Bitişe",
  trust_secure: "Güvenli ödeme",
  trust_secure_d: "Güvenebileceğiniz şifreli ödeme",
  trust_protection: "Alıcı koruması",
  trust_protection_d: "Ulaşmazsa tam iade",
  trust_returns: "Kolay iade",
  trust_returns_d: "Zahmetsiz iade politikası",
  trust_support: "7/24 destek",
  trust_support_d: "İhtiyacınız olduğunda buradayız",
  newsletter_title: "Özel fırsatlar e-postanıza gelsin",
  newsletter_sub: "Yeni ürün ve tekliflere erken erişim için abone olun.",
  subscribe: "Abone ol",
  email_placeholder: "E-postanızı girin",
  subscribed: "Abone olduğunuz için teşekkürler!",
  add_to_cart: "Sepete ekle",
  buy_now: "Hemen al",
  in_stock: "Stokta",
  out_of_stock: "Stokta yok",
  reviews: "değerlendirme",
  no_reviews: "Henüz değerlendirme yok",
  reviews_tab: "Değerlendirmeler",
  order_confirmed: "Sipariş onaylandı",
  color: "Renk",
  size: "Beden",
  quantity: "Adet",
  add_to_wishlist: "Favorilere ekle",
  in_wishlist: "Favorilerde",
  description: "Açıklama",
  specifications: "Özellikler",
  related_products: "İlgili ürünler",
  similar_products: "Bunları da beğenebilirsin",
  frequently_bought: "Sık birlikte alınanlar",
  estimated_delivery: "Tahmini teslimat",
  ships_to: "Gönderim",
  buyer_protection: "Alıcı koruması ve garantiler",
  select_options: "Seçenekleri seç",
  filters: "Filtreler",
  sort: "Sırala",
  price: "Fiyat",
  rating: "Puan",
  availability: "Durum",
  in_stock_only: "Sadece stoktakiler",
  on_sale: "İndirimde",
  brand: "Marka",
  apply: "Uygula",
  clear_all: "Temizle",
  sort_relevance: "İlgi",
  sort_price_asc: "Fiyat: artan",
  sort_price_desc: "Fiyat: azalan",
  sort_rating: "En yüksek puan",
  sort_newest: "En yeni",
  results: "sonuç",
  min: "En az",
  max: "En çok",
  no_products_title: "Henüz gösterilecek ürün yok",
  no_products_body: "WooCommerce mağazanızı bağlayın veya filtreleri değiştirin.",
  connect_store: "Ürünler, fiyatlar ve stok WooCommerce'den yüklenir.",
  cart_title: "Sepet",
  cart_empty_title: "Sepetiniz boş",
  cart_empty_body: "Mağazayı gezin ve beğendiklerinizi ekleyin.",
  subtotal: "Ara toplam",
  shipping: "Kargo",
  shipping_calc: "Ödeme adımında hesaplanır",
  estimated_total: "Tahmini toplam",
  coupon: "Kupon kodu",
  proceed_checkout: "Ödemeye geç",
  remove: "Kaldır",
  save_for_later: "Sonrası için kaydet",
  continue_shopping: "Alışverişe devam",
  checkout_title: "Ödeme",
  contact_info: "İletişim bilgileri",
  shipping_address: "Teslimat adresi",
  billing_same: "Fatura adresi teslimat ile aynı",
  full_name: "Ad soyad",
  email: "E-posta",
  phone: "Telefon",
  country: "Ülke",
  city: "Şehir",
  postal_code: "Posta kodu",
  address_line: "Adres",
  shipping_method: "Kargo yöntemi",
  payment_method: "Ödeme yöntemi",
  payment_note: "Ödeme sağlayıcıları modülerdir ve WooCommerce'e bağlanır. Kart verisi burada saklanmaz.",
  order_notes: "Sipariş notu (isteğe bağlı)",
  place_order: "Siparişi tamamla",
  order_summary: "Sipariş özeti",
  dashboard: "Panel",
  my_orders: "Siparişlerim",
  addresses: "Adresler",
  profile: "Profil",
  security: "Güvenlik",
  welcome_back: "Tekrar hoş geldiniz",
  no_orders_title: "Henüz sipariş yok",
  no_orders_body: "Sipariş verdiğinizde canlı durum ve takip ile burada görünür.",
  order_number: "Sipariş no",
  status: "Durum",
  total: "Toplam",
  view: "Görüntüle",
  st_received: "Sipariş alındı",
  st_processing: "Hazırlanıyor",
  st_purchased: "Tedarikçiden alındı",
  st_preparing: "Gönderim hazırlanıyor",
  st_shipped: "Kargolandı",
  st_in_transit: "Yolda",
  st_delivered: "Teslim edildi",
  st_cancelled: "İptal edildi",
  st_refunded: "İade edildi",
  track_title: "Siparişini takip et",
  track_sub: "En son durumu görmek için sipariş numaranı gir.",
  tracking_number: "Takip numarası",
  carrier: "Kargo firması",
  timeline: "Gönderi zaman çizelgesi",
  track_btn: "Takip et",
  no_tracking: "Bu sipariş için henüz takip bilgisi yok.",
  sign_in: "Giriş yap",
  create_account: "Hesap oluştur",
  password: "Şifre",
  name: "Ad",
  no_account: "KHA'da yeni misin?",
  have_account: "Zaten hesabın var mı?",
  auth_local_note: "Hesaplar, backend bağlandığında WooCommerce müşteri hesaplarına bağlanır.",
  auth_failed_generic: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  forgot_password: "Şifremi unuttum",
  send_reset_link: "Sıfırlama bağlantısı gönder",
  reset_sent: "E-posta kayıtlıysa şifre sıfırlama bağlantısı gönderildi.",
  reset_done: "Şifre güncellendi. Artık yeni şifrenizle giriş yapabilirsiniz.",
  reset_note: "Hesabınız için yeni bir şifre seçin.",
  reset_password_btn: "Yeni şifreyi kaydet",
  or_continue_with: "veya şununla devam et",
  google_sign_in: "Google ile giriş yap",
  google_not_configured: "Google girişi henüz yapılandırılmadı. Mağaza sahibinin ayarlarda Google OAuth bilgilerini eklemesi gerekiyor.",
  current_password: "Mevcut şifre",
  new_password: "Yeni şifre",
  profile_saved: "Profil başarıyla güncellendi.",
  about_us: "Hakkımızda",
  contact_us: "Bize Ulaşın",
  shipping_policy: "Kargo ve Teslimat",
  returns_policy: "İade ve Geri Ödeme",
  cancellation_policy: "İptal",
  terms_conditions: "Şartlar ve Koşullar",
  privacy_policy: "Gizlilik Politikası",
  cookie_policy: "Çerez Politikası",
  faq: "SSS",
  order_tracking: "Sipariş Takibi",
  home: "Ana sayfa",
  page_not_found: "Sayfa bulunamadı",
  go_home: "Ana sayfaya dön",
};

const ar = {
  search_placeholder: "ابحث عن منتجات وعلامات وفئات",
  all_categories: "كل الفئات",
  account: "الحساب",
  hello_sign_in: "مرحباً، سجّل الدخول",
  my_account: "حسابي",
  orders: "الطلبات",
  wishlist: "المفضّلة",
  cart: "السلة",
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  logout: "تسجيل الخروج",
  track_order: "تتبّع الطلب",
  language: "اللغة",
  currency: "العملة",
  announce_shipping: "شحن مجاني للطلبات فوق 50$ · توصيل لكل العالم",
  announce_protection: "حماية المشتري على كل طلب",
  hero_title: "اكتشف أكثر. وادفع أقل.",
  hero_subtitle: "آلاف المنتجات في سوق واحد فاخر.",
  shop_now: "تسوّق الآن",
  explore_deals: "استكشف العروض",
  featured_categories: "فئات مميّزة",
  best_sellers: "الأكثر مبيعاً",
  trending: "الرائج الآن",
  flash_deals: "عروض خاطفة",
  new_arrivals: "وصل حديثاً",
  recommended: "موصى به لك",
  recently_viewed: "شاهدت مؤخراً",
  view_all: "عرض الكل",
  ends_in: "ينتهي خلال",
  trust_secure: "دفع آمن",
  trust_secure_d: "دفع مشفّر تثق به",
  trust_protection: "حماية المشتري",
  trust_protection_d: "استرداد كامل إن لم يصل",
  trust_returns: "إرجاع سهل",
  trust_returns_d: "سياسة إرجاع بلا متاعب",
  trust_support: "دعم 24/7",
  trust_support_d: "نحن هنا وقتما تحتاج",
  newsletter_title: "احصل على عروض حصرية في بريدك",
  newsletter_sub: "اشترك للوصول المبكر للمنتجات والعروض.",
  subscribe: "اشترك",
  email_placeholder: "أدخل بريدك الإلكتروني",
  subscribed: "شكراً لاشتراكك!",
  add_to_cart: "أضف إلى السلة",
  buy_now: "اشترِ الآن",
  in_stock: "متوفّر",
  out_of_stock: "غير متوفّر",
  reviews: "تقييم",
  no_reviews: "لا توجد تقييمات بعد",
  reviews_tab: "التقييمات",
  order_confirmed: "تم تأكيد الطلب",
  color: "اللون",
  size: "المقاس",
  quantity: "الكمية",
  add_to_wishlist: "أضف للمفضّلة",
  in_wishlist: "في المفضّلة",
  description: "الوصف",
  specifications: "المواصفات",
  related_products: "منتجات ذات صلة",
  similar_products: "قد يعجبك أيضاً",
  frequently_bought: "يُشترى معاً غالباً",
  estimated_delivery: "التوصيل المتوقّع",
  ships_to: "الشحن إلى",
  buyer_protection: "حماية المشتري والضمانات",
  select_options: "اختر الخيارات",
  filters: "الفلاتر",
  sort: "ترتيب",
  price: "السعر",
  rating: "التقييم",
  availability: "التوفّر",
  in_stock_only: "المتوفّر فقط",
  on_sale: "عروض",
  brand: "العلامة",
  apply: "تطبيق",
  clear_all: "مسح الكل",
  sort_relevance: "الأكثر صلة",
  sort_price_asc: "السعر: من الأقل",
  sort_price_desc: "السعر: من الأعلى",
  sort_rating: "الأعلى تقييماً",
  sort_newest: "الأحدث",
  results: "نتيجة",
  min: "الأدنى",
  max: "الأعلى",
  no_products_title: "لا توجد منتجات لعرضها بعد",
  no_products_body: "اربط متجر WooCommerce أو عدّل الفلاتر لعرض المنتجات هنا.",
  connect_store: "المنتجات والأسعار والمخزون تُحمّل من WooCommerce.",
  cart_title: "سلة التسوّق",
  cart_empty_title: "سلتك فارغة",
  cart_empty_body: "تصفّح المتجر وأضف ما يعجبك.",
  subtotal: "المجموع الفرعي",
  shipping: "الشحن",
  shipping_calc: "يُحتسب عند الدفع",
  estimated_total: "الإجمالي المتوقّع",
  coupon: "رمز الخصم",
  proceed_checkout: "متابعة الدفع",
  remove: "إزالة",
  save_for_later: "احفظ لاحقاً",
  continue_shopping: "متابعة التسوّق",
  checkout_title: "الدفع",
  contact_info: "معلومات التواصل",
  shipping_address: "عنوان الشحن",
  billing_same: "عنوان الفوترة نفس عنوان الشحن",
  full_name: "الاسم الكامل",
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  country: "الدولة",
  city: "المدينة",
  postal_code: "الرمز البريدي",
  address_line: "العنوان",
  shipping_method: "طريقة الشحن",
  payment_method: "طريقة الدفع",
  payment_note: "بوابات الدفع معيارية وتتصل بـ WooCommerce. لا تُخزّن بيانات البطاقة هنا.",
  order_notes: "ملاحظات الطلب (اختياري)",
  place_order: "إتمام الطلب",
  order_summary: "ملخّص الطلب",
  dashboard: "لوحة التحكّم",
  my_orders: "طلباتي",
  addresses: "العناوين",
  profile: "الملف الشخصي",
  security: "الأمان",
  welcome_back: "مرحباً بعودتك",
  no_orders_title: "لا توجد طلبات بعد",
  no_orders_body: "عند إنشاء طلب سيظهر هنا مع الحالة والتتبّع مباشرةً.",
  order_number: "رقم الطلب",
  status: "الحالة",
  total: "الإجمالي",
  view: "عرض",
  st_received: "تم استلام الطلب",
  st_processing: "قيد المعالجة",
  st_purchased: "تم الشراء من المورّد",
  st_preparing: "تجهيز الشحنة",
  st_shipped: "تم الشحن",
  st_in_transit: "في الطريق",
  st_delivered: "تم التسليم",
  st_cancelled: "ملغي",
  st_refunded: "مسترد",
  track_title: "تتبّع طلبك",
  track_sub: "أدخل رقم طلبك لعرض آخر حالة.",
  tracking_number: "رقم التتبّع",
  carrier: "شركة الشحن",
  timeline: "الجدول الزمني للشحنة",
  track_btn: "تتبّع",
  no_tracking: "لا تتوفّر معلومات تتبّع لهذا الطلب بعد.",
  sign_in: "تسجيل الدخول",
  create_account: "إنشاء حساب",
  password: "كلمة المرور",
  name: "الاسم",
  no_account: "جديد على KHA؟",
  have_account: "لديك حساب بالفعل؟",
  auth_local_note: "تتصل الحسابات بحسابات عملاء WooCommerce عند ربط الخادم.",
  auth_failed_generic: "حدث خطأ ما. حاول مرة أخرى.",
  forgot_password: "نسيت كلمة المرور؟",
  send_reset_link: "إرسال رابط الاستعادة",
  reset_sent: "إذا كان البريد مسجلاً، فقد أرسلنا رابط استعادة كلمة المرور.",
  reset_done: "تم تحديث كلمة المرور. يمكنك الآن الدخول بكلمتها الجديدة.",
  reset_note: "اختر كلمة مرور جديدة لحسابك.",
  reset_password_btn: "تعيين كلمة المرور الجديدة",
  or_continue_with: "أو تابع باستخدام",
  google_sign_in: "الدخول عبر Google",
  google_not_configured: "تسجيل الدخول عبر Google غير مفعّل بعد. يحتاج صاحب المتجر لإضافة بيانات Google OAuth في الإعدادات.",
  current_password: "كلمة المرور الحالية",
  new_password: "كلمة المرور الجديدة",
  profile_saved: "تم تحديث الملف الشخصي بنجاح.",
  about_us: "من نحن",
  contact_us: "تواصل معنا",
  shipping_policy: "الشحن والتوصيل",
  returns_policy: "الإرجاع والاستبدال",
  cancellation_policy: "الإلغاء",
  terms_conditions: "الشروط والأحكام",
  privacy_policy: "سياسة الخصوصية",
  cookie_policy: "سياسة الكوكيز",
  faq: "الأسئلة الشائعة",
  order_tracking: "تتبع الطلب",
  home: "الرئيسية",
  page_not_found: "الصفحة غير موجودة",
  go_home: "العودة للرئيسية",
};

export const translations = { en, tr, ar };

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "tr", label: "Türkçe", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
];

export const CURRENCIES = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "TRY", symbol: "₺" },
];
